module.exports = __webpack_public_path__ + "static/assets/a6b0f453205a7ff228cfba107ee5b97d.png";